var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{staticClass:"wrapper"},[_c('transition',{attrs:{"name":"slide"}},[(_vm.visible)?_c('v-flex',{staticClass:"bar",attrs:{"xs12":""}},[_c('v-toolbar',{attrs:{"color":"earth"}},[_vm._t("default")],2)],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }